import type { TFunction } from 'commonTypes';
import type { MerchantUserFeeResponce } from 'store/models';

export const getMerchantUserFeeTranslation = (fee: MerchantUserFeeResponce | string, t: TFunction) => {
  const isStringFee = typeof fee === 'string';
  const percentageValue = isStringFee ? fee.replace('%', '') : fee.percentage?.toString() || '';
  const percentageTranslation = percentageValue
    ? t('PH.FEE.MESSAGE', {
        percentage: `${percentageValue}`,
      })
    : '';
  const fixedFee = !isStringFee && fee.fix ? ` + ${fee.fix}` : '';

  return `${percentageTranslation}${fixedFee}`;
};
